module.exports = __webpack_public_path__ + "static/media/piper-notificacion.69141051.svg";